<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-actions>
    <f7-actions-group>
      <f7-actions-label v-if="currentOption">{{ currentOption.title }}</f7-actions-label>
    </f7-actions-group>
    <f7-actions-group>
      <f7-actions-button @click="$f7.views.main.router.navigate(`/stores/${storeIdProp}/menu-drafts/${menuDraftVariationProp}/edit-option`)">
        <font-awesome-icon icon="edit" style="margin-right: 5px;" />
        編輯選項內容
      </f7-actions-button>
      <f7-actions-button @click="$f7.views.main.router.navigate(`/stores/${storeIdProp}/menu-drafts/${menuDraftVariationProp}/duplicate-actions`)">
        <font-awesome-icon :icon="['far', 'copy']" style="margin-right: 5px;" />
        複製選項內容
      </f7-actions-button>
      <f7-actions-button color="red" @click="deleteOptionOnClick">
        <font-awesome-icon icon="trash" style="margin-right: 10px;" />
        刪除選項內容
      </f7-actions-button>
    </f7-actions-group>
  </f7-actions>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'OptionActionSheet',
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String,
    optionIdProp: String
  },
  computed: {
    ...mapState('menuDraftModule', ['currentElementPath', 'currentDraft']),
    categoryId () { return this.currentElementPath[0].id },
    groupId () { return this.currentElementPath[1].id },
    itemId () { return this.currentElementPath[2].id },
    questionId () { return (this.currentElementPath[5] || this.currentElementPath[3]).id },
    optionId () {
      const currentOptionPathInfo = this.currentElementPath[6] || this.currentElementPath[4]
      return currentOptionPathInfo ? currentOptionPathInfo.id : null
    },
    elementLevel () { return this.currentElementPath.length === 7 ? 6 : 4 },
    optionIndex () { return this.currentElementPath[this.elementLevel].index },
    currentOption () { return this.currentDraft.options[this.optionId] }
  },
  methods: {
    ...mapActions('menuDraftModule', ['setCurrentElementPath', 'deleteOption']),
    deleteOptionOnClick () {
      this.$f7.dialog.confirm(`確定要刪除 ${this.currentOption.title} ?`, '刪除選項內容', () => {
        this.deleteOption({ questionId: this.questionId, optionId: this.optionId, index: this.optionIndex, elementLevel: this.elementLevel })
      })
    }
  }
}
</script>
